import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaInstagram, FaLinkedin, FaYoutube, FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // Se estiver na homepage, faz scroll suave
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Se estiver em outra página, navega para homepage + seção
      window.location.href = `/#${sectionId}`;
    }
    setIsMobileMenuOpen(false);
  };

  const navigateToPage = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  // Função para navegar para páginas de serviços com scroll para o topo
  const navigateToService = (href) => {
    window.scrollTo(0, 0);
    window.location.href = href;
  };

  const navItems = [
    { id: 'inicio', label: 'Início' },
    { id: 'quem-somos', label: 'Sobre Nós' },
    { 
      id: 'servicos', 
      label: 'Serviços',
      hasDropdown: true,
      dropdownItems: [
        { id: 'desenvolvimento-sistemas', label: 'Desenvolvimento de Sistemas', href: '/servicos/desenvolvimento-sistemas' },
        { id: 'criacao-sites', label: 'Criação de Sites', href: '/servicos/criacao-sites' },
        { id: 'prototipacao', label: 'Prototipação', href: '/servicos/prototipacao' },
        { id: 'consultorias', label: 'Consultorias', href: '/servicos/consultorias' }
      ]
    },
    { id: 'solucoes', label: 'Soluções' },
    // { id: 'segmentos', label: 'Segmentos' },
    // { id: 'clientes', label: 'Clientes' },
    { id: 'contato', label: 'Contato' }
  ];

  return (
    <motion.nav 
      className={`navbar ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-brand">
            <button
              className="logo-btn"
              onClick={() => scrollToSection('inicio')}
              style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
              aria-label="Ir para o início"
            >
              <img src={require('../assets/LogoPrincipal.jpg')} alt="MicroCodie" loading="lazy" />
            </button>
          </div>

          <div className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <ul className="navbar-nav">
              {navItems.map((item) => (
                <li key={item.id} className={item.hasDropdown ? 'nav-item-dropdown' : ''}>
                  {item.hasDropdown ? (
                    <div 
                      className="nav-link-dropdown"
                      onMouseEnter={() => setIsServicesDropdownOpen(true)}
                      onMouseLeave={() => setIsServicesDropdownOpen(false)}
                    >
                      <button className="nav-link">
                        {item.label}
                        <FaChevronDown className="dropdown-arrow" />
                      </button>
                      <div className={`dropdown-menu ${isServicesDropdownOpen ? 'show' : ''}`}>
                        {item.dropdownItems.map((dropdownItem) => (
                          <button 
                            key={dropdownItem.id}
                            onClick={() => navigateToService(dropdownItem.href)}
                            className="dropdown-item"
                          >
                            {dropdownItem.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <button 
                      onClick={() => {
                        if (item.id === 'quem-somos') {
                          navigateToPage('/quem-somos');
                        } else {
                          scrollToSection(item.id);
                        }
                      }}
                      className="nav-link"
                    >
                      {item.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="navbar-social">
            <a href="https://instagram.com/microcodie" target="_blank" rel="noopener noreferrer" aria-label="Instagram da MicroCodie">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/company/microcodiesoftware/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn da MicroCodie">
              <FaLinkedin />
            </a>
            <a href="https://www.youtube.com/@Microcodie_" target="_blank" rel="noopener noreferrer" aria-label="YouTube da MicroCodie">
              <FaYoutube />
            </a>
          </div>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? "Fechar menu" : "Abrir menu"}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar; 